/**
 * @module utils/array
 */

export function Search (array, name, value) {
  for (let i = 0; i < array.length; i++) {
    if (array[i][name] === value) {
      return array[i]
    }
  }
  return false
}
/**
 * if the Note consists of string array cobines the array in one string and sets the new line characters
 * in order to format text in UI
 * @param {*} array
 */
export function formatArrayToString (array) {
  if (typeof array === 'object') {
    let str = ''
    for (let i = 0; i < array.length; i++) {
      str += array[i] + '\n'
    }
    return str
  } else {
    return array
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/array.js